import type { UI } from '@/v2/types';
import React from 'react';
import { Flex } from '@qga/roo-ui/components';

import useSearchQuery from '@shared/v2/hooks/useSearchQuery';
import { PackageOption as PackageOptionType } from '@shared/v2/utils/getPackageOptions';

import PackageHeroSummary from '@/components/PackageHeroSummary';
import { PackagePagePriceWithCompactPointsPlusPay } from '@/v2/components/pages/PackageView/components/PackagePagePrice';
import { useSearchPanelControls } from '@/v2/components/pages/PackageView/contexts/SearchPanelControlsContext';
import { Dates, PackageDetails } from './components';

export type FooterSelectedRoomProps = {
  selectedPackageOption?: PackageOptionType;
  selectedRoomOption?: UI.RoomOption;
};

const FooterSelectedRoom = ({
  selectedRoomOption,
  selectedPackageOption,
}: FooterSelectedRoomProps) => {
  // Search Controls
  const { openCalendar, openMobileSearchPanelModal } = useSearchPanelControls();
  const handleDateClick = () => {
    openCalendar();
    openMobileSearchPanelModal();
  };

  // Query Param Data
  const { searchQuery } = useSearchQuery();
  const { adults, children, infants, returnDate, departureDate } =
    searchQuery || {};

  // Room Data
  const { matchingOffer } = selectedRoomOption || {};

  if (!matchingOffer) {
    return null;
  }

  return (
    <Flex alignItems="flex-start" flexDirection="column">
      <PackageHeroSummary searchQuery={searchQuery} showNights exact />
      <PackagePagePriceWithCompactPointsPlusPay
        charges={matchingOffer.charges}
        travellers={{ adults, children, infants }}
        offerId={matchingOffer.hotelOffer.id}
      />
      <Dates
        onClick={handleDateClick}
        departureDate={departureDate}
        returnDate={returnDate}
      />
      <PackageDetails
        packageOption={selectedPackageOption}
        roomOption={selectedRoomOption}
      />
    </Flex>
  );
};

export default FooterSelectedRoom;
